'use strict';
module.exports = function goldSessionNodeSelectionWidget({goldSessionNodeSelectionTracker, goldSessionModel, mapView, splittableModel, navigatorShim}) {
	if (!goldSessionNodeSelectionTracker || !goldSessionModel || !mapView || !splittableModel) {
		throw new Error('invalid-args');
	}
	const sessionDOMs = {},
		delayedNodeSelectionChanged = {},
		createSessionDOM = (ownerDocument, evt) => {
			const sessionDOM = ownerDocument.createElement('microSwatch');
			sessionDOM.style.backgroundColor = evt.senderSession.color;
			sessionDOMs[evt.senderSession.sessionId] = sessionDOM;
			sessionDOM.setAttribute('data-mm-tooltip', evt.senderSession.description);
			sessionDOM.classList.add('tooltip-below');
			sessionDOM.addEventListener('click', e => {
				e.preventDefault();
				e.stopPropagation();
				splittableModel.showGoldSessions();
			});
			return sessionDOM;
		},
		createContainerDOM = nodeDOM => {
			const containerDOM = nodeDOM.ownerDocument.createElement('div');
			containerDOM.setAttribute('data-mm-role', 'gold-session-dots');
			containerDOM.classList.add('gold-session-dots');
			nodeDOM.append(containerDOM);
			return containerDOM;
		},
		onNodeSelectionChanged = evt => {
			const {nodeId, senderSession} = evt,
				{sessionId} = senderSession,
				nodeDOM = mapView.nodeWithId(nodeId);
			if (nodeDOM) {
				delete delayedNodeSelectionChanged[sessionId];
				const containerDOM = nodeDOM.querySelector('[data-mm-role~="gold-session-dots"]') || createContainerDOM(nodeDOM),
					sessionDOM = sessionDOMs[sessionId] || createSessionDOM(nodeDOM.ownerDocument, evt);
				containerDOM.append(sessionDOM);
			} else {
				delayedNodeSelectionChanged[sessionId] = evt;
			}

		},
		checkForPending = () => {
			Object.values(delayedNodeSelectionChanged).forEach(onNodeSelectionChanged);
		};
	goldSessionNodeSelectionTracker.addEventListener('nodeSelectionChanged', onNodeSelectionChanged);
	navigatorShim.setInterval(checkForPending, 2000);
	goldSessionModel.addEventListener('sessionRemoved', ({sessionId}) => {
		const sessionDOM =  sessionDOMs[sessionId];
		if (sessionDOM) {
			sessionDOM.remove();
			delete sessionDOMs[sessionId];
		}
	});

};
